import Accessories from './Accessories'

export default Accessories